import React, { useEffect, useRef } from "react";

const DocSidebar = ({ items = [], activeSection = "", setActiveSection }) => {
  const observer = useRef(null);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
      if (setActiveSection) {
        setActiveSection(id);
      }
    }
  };

  useEffect(() => {
    if (!items || items.length === 0) return;

    const options = {
      root: null,
      rootMargin: "-15% 0px -65% 0px",
      threshold: 0,
    };

    observer.current = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && setActiveSection) {
          setActiveSection(entry.target.id);
        }
      });
    }, options);

    const sectionIds = items.map((item) => item.id);
    const sections = document.querySelectorAll(
      sectionIds.map((id) => `#${id}`).join(",")
    );
    sections.forEach((section) => observer.current?.observe(section));

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, [items, setActiveSection]);

  return (
    <div className="lg:w-[260px] flex-shrink-0">
      <div className="sticky top-24 max-h-[calc(100vh-120px)] overflow-y-auto pr-2 custom-scrollbar">
        <nav className="flex flex-col gap-0.5">
          {items.map((item) => {
            if (item.type === "category") {
              return (
                <div key={item.id} className="px-4 py-2 mt-4 first:mt-0">
                  <span className="font-['Axiforma'] font-black text-sm text-[#000000]">
                    {item.label}
                  </span>
                </div>
              );
            }
            if (item.type === "heading") {
              return (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-left px-4 py-2 mt-2 transition-colors hover:text-[#17A257]"
                >
                  <span className="font-['Axiforma'] font-black text-sm text-[#000000] hover:text-[#17A257] transition-colors">
                    {item.label}
                  </span>
                </button>
              );
            }
            const isActive = activeSection === item.id;
            return (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`text-left px-4 py-1.5 rounded-lg transition-all duration-150 group relative ${
                  isActive
                    ? "text-[#17A257] bg-[#E7F6EC] font-black"
                    : "text-[#1D2129]/70 hover:text-[#1D2129] hover:bg-gray-50/80 font-medium"
                } ${item.indent ? "ml-4" : ""}`}
              >
                <span className="text-sm">
                  {item.label}
                </span>
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default DocSidebar;
